import {Component, Inject, Input, OnChanges, QueryList, SimpleChanges, TemplateRef, ViewChild, ViewChildren} from '@angular/core';
import {ViewId, WORKBENCH_VIEW_CONFIG, WorkbenchViewConfig} from '../../types';
import {WmTemplate} from "@webmate-web-core/shared/directives/template.directive";
import {WorkbenchLayoutManager} from "../../services/workbench-layout-manager.service";

@Component({
    selector: 'wm-workbench-view',
    template:'<ng-content></ng-content>',
})
export class WorkbenchViewComponent {
    viewId?: ViewId;

    @ViewChildren(WmTemplate) headerTemplates: QueryList<WmTemplate>;

    // view header template views. Overrides the default. Overridden by stackHeaderTemplate and tabHeaderTemplate
    headerTemplate: TemplateRef<any>;

    // view header template for stacked views. Overrides the headerTemplate
    stackHeaderTemplate: TemplateRef<any>;

    // view header template for tabbed views. Overrides the headerTemplate
    tabHeaderTemplate: TemplateRef<any>;

    constructor(public layoutManager: WorkbenchLayoutManager, @Inject(WORKBENCH_VIEW_CONFIG) public config?: WorkbenchViewConfig<any>) {
        if (!!this.config) {
            this.viewId = this.config.id;
        }
    }

    beforeViewClose() {
        // This is executed right before the layout manager hides the view
        // Overwrite in subclass
    }

    ngAfterViewInit() {
        setTimeout(() => {
            this.headerTemplates.forEach(template => {
                if (!template.name) {
                    this.headerTemplate = template.template;
                } else if (template.name === 'stackHeader') {
                    this.stackHeaderTemplate = template.template;
                } else if (template.name === 'tabHeader') {
                    this.tabHeaderTemplate = template.template;
                }
            });
        });
    }

}
